/* template */
<template minapp="mpx" xlang="wxml"><div :class="({ 'scrambling':isBeforeScrambled  })" class="order-head"><div class="order-head-info"><template><div class="order-head-image"><mpx-image :src="(stateImage)" mode="heightFix" class="image"/></div></template><div :class="(stateTextWrapClass)" class="order-head-info-text"><div :class="(stateTextClass.title)"><div>{{ stateText.title }}</div><div class="prog-num" v-if="(showAnimate)">{{ parseInt(progress * 100)}}%</div></div><div class="prog-wrap" v-if="(showAnimate)"><div ref="__mpx_ref_progref__" class="prog-bg"></div><div :style="[(progStyle)] | transRpxStyle" class="prog"></div></div><div :class="(stateTextClass.subTitle)"><span v-for="(item, index) in (subTitleTexts)" :class="({highlight:item.highlight})">{{item.value}}</span></div></div></div><div class="notice-tip-content" v-if="(!this.occupying && serviceNoticeList && serviceNoticeList.length)"><notice-tip v-for="(item, index) in (serviceNoticeList)" :key="item.index" :titleText="(item.title)" :noticeTitle="(item.noticeTitle)" type="order" @click="showNoticeTipsPop(index)" class="notice"/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m1d2f5e66"}'>
  @import '~@/mixins/stylus/color.styl'

  .order-head
    padding 16px 12px
    color #ffffff
    background $train-color-theme-blue
    padding 0 10px 10px 10px
    background #FFFFFF
    .circle-wrap
      margin-right 8px
      .circle-inner
        position relative
        display flex
      @keyframes turn
        0%
          transform rotate(0deg)
        100%
          transform rotate(360deg)
      .circle
        width 46px
        height 46px
        flex 1
        animation turn 1.2s linear infinite
      .lightning
        width 16px
        height 16px
        position absolute
        top 50%
        left 50%
        transform translate(-50%,-50%)
    &.scrambling
      background none
      padding-top 2px
    .order-head-info
      display flex
      .order-head-image
        margin-right 10px
        width 74px
        height 74px
        .image 
          height 74px
      .order-head-info-icon
        font-size 24px
        line-height 24px
        margin-right 4px
      .order-head-info-text
        color #ffffff
        flex 1
        padding-right 20px
        justify-content center
        display flex
        flex-direction column
        .prog-wrap
          position relative
          margin-top 10px
          .prog-bg
            height: 10px;
            border-radius: 5px;
            background: #E4EAEF;
          .prog
            position absolute
            top 0
            left 0
            width 0px
            height 10px
            border-radius 5px
            background #FF6400
        .order-state-name
          display flex
          justify-content space-between
          color #000000
          font-weight 500
          font-size 22px
          line-height 22px
          font-family PingFangSC-Medium
        .order-state-detail
          white-space pre-wrap
          font-family PingFangSC-Regular
          line-height 17px
          font-weight normal
          font-size 12px
          color #666666
          margin-top 8px
          padding-right 0
          .highlight
            color #FF6F2A
            font-family PingFangSC-Semibold
      .prog-num
        font-family: Barlow Semi Condensed;
        font-size: 22px;
        font-weight: normal;
        line-height: 22px;
        color: #FF6400;
    .notice-tip-content
      display flex
      flex-direction column
      margin-top 10px
    .notice
      margin-top 1px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1d2f5e66"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-detail-head-state-card.mpx.js?isComponent&outputPath=components%2Forder-detail-head-state-card1d2f5e66%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-detail-head-state-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Forder-detail-head-state-card1d2f5e66%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1d2f5e66"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/order-detail-head-state-card1d2f5e66/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'notice-tip':getComponent(require("../../../material/block/notice/noticeTip.mpx?isComponent&outputPath=components%2FnoticeTip87cd944c%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
